<!--
    描述： 跟踪审计 数据对比列表页面
    时间： 2020/5/29
    created by zjj
-->
<template>
	<div class="track-comparison-table"
		 ref="tableContent">
		<el-table :data="tableData"
				  :height="tableH"
				  row-key="id"
				  ref="xTable"
				  border
				  stripe
				  highlight-current-row
				  :expand-row-keys="expandKeys"
				  :row-class-name="rowClassName">
			<el-table-column prop="numberDatas"
							 label="期数"
							 align="center"
							 show-overflow-tooltip
							 min-width="90">
			</el-table-column>
			<el-table-column prop="applyDate"
							 label="申请时间"
							 align="center"
							 show-overflow-tooltip
							 min-width="125">
			</el-table-column>
			<el-table-column prop="sindex"
							 label="申报描述"
							 align="center"
							 show-overflow-tooltip
							 v-if="filterColumns.Declare.indexOf('sindex')>=0"
							 min-width="125">
			</el-table-column>
			<el-table-column prop="costName"
							 label="审核描述"
							 align="center"
							 show-overflow-tooltip
							 v-if="filterColumns.Declare.indexOf('costName')>=0"
							 min-width="125">
			</el-table-column>
			<el-table-column prop="current"
							 header-align="center"
							 v-if="filterColumns.current.length > 0"
							 :label="`当期金额 (${unitName})`">
				<el-table-column prop="taostValue"
								 label="申报金额"
								 v-if="filterColumns.current.indexOf('taostValue')>=0"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.taostValue : (scope.row.taostValue/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="costProportion"
								 label="申请占比"
								 v-if="filterColumns.current.indexOf('costProportion')>=0"
								 class-name="percent-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="110">
					<template slot-scope="scope">
						<div>{{ scope.row.costProportion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="costMoney"
								 label="审核金额"
								 v-if="filterColumns.current.indexOf('costMoney')>=0"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.costMoney : (scope.row.costMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="costPortion"
								 label="审核占比"
								 v-if="filterColumns.current.indexOf('costPortion')>=0"
								 class-name="percent-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.costPortion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="tostValue"
								 label="签证金额"
								 v-if="filterColumns.current.indexOf('tostValue')>=0"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
            <div>
							{{ unitName === '元' ? scope.row.tostValue : (scope.row.tostValue/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sunProportion"
								 label="签证占比"
								 v-if="filterColumns.current.indexOf('sunProportion')>=0"
								 class-name="percent-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.sunProportion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="sunMoney"
								 label="支付金额"
								 v-if="filterColumns.current.indexOf('sunMoney')>=0"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope" slot="header">
						<div>支付金额 <i class="el-icon-edit ml5 cursor-pointer" @click="setPayMoney('设置支付金额', 'sunMoney')"></i></div>
					</template>
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.sunMoney : (scope.row.sunMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="applyProportion"
								 label="支付占比"
								 v-if="filterColumns.current.indexOf('applyProportion')>=0"
								 class-name="percent-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.applyProportion }}</div>
					</template>
				</el-table-column>
			</el-table-column>
			<el-table-column prop="total"
							 header-align="center"
							 v-if="filterColumns.total.length > 0"
							 class-name="period-column border-left-column"
							 :label="`累计金额 (${unitName})`">
				<el-table-column prop="applyMoney"
								 label="申报金额"
								 v-if="filterColumns.total.indexOf('applyMoney')>=0"
								 class-name="border-left-column period-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.applyMoney : (scope.row.applyMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="applyPtion"
								 label="申请占比"
								 v-if="filterColumns.total.indexOf('applyPtion')>=0"
								 class-name="percent-column period-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.applyPtion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="approvalMoney"
								 label="审核金额"
								 v-if="filterColumns.total.indexOf('approvalMoney')>=0"
								 header-align="center"
								 align="right"
								 class-name="period-column"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.approvalMoney : (scope.row.approvalMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="approvalProportion"
								 label="批准占比"
								 v-if="filterColumns.total.indexOf('approvalProportion')>=0"
								 class-name="percent-column period-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.approvalProportion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="visaMoney"
								 label="签证金额"
								 v-if="filterColumns.total.indexOf('visaMoney')>=0"
								 header-align="center"
								 align="right"
								 class-name="period-column"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.visaMoney : (scope.row.visaMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="visaProportion"
								 label="签证占比"
								 v-if="filterColumns.total.indexOf('visaProportion')>=0"
								 class-name="percent-column period-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.visaProportion }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="payMoney"
								 label="支付金额"
								 v-if="filterColumns.total.indexOf('payMoney')>=0"
								 header-align="center"
								 align="right"
								 class-name="period-column"
								 show-overflow-tooltip
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ unitName === '元' ? scope.row.payMoney : (scope.row.payMoney/10000).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="payProportion"
								 label="支付占比"
								 v-if="filterColumns.total.indexOf('payProportion')>=0"
								 class-name="percent-column period-column"
								 header-align="center"
								 align="right"
								 show-overflow-tooltip
								 min-width="90">
					<template slot-scope="scope">
						<div>{{ scope.row.payProportion }}</div>
					</template>
				</el-table-column>
			</el-table-column>
		</el-table>
		<!--  支付金额弹窗  -->
		<el-dialog :visible.sync="payDialog.visible" :width="payDialog.width" :title="payDialog.title" :close-on-click-modal="false">
			<el-row v-for="(item, index) in editData" :key="'pay' + index" class="mb10">
				<el-col :span="4" class="line-row text-center">{{ item.numberDatas + ': ' }}</el-col>
				<el-col :span="20">
					<el-input
							type="number"
							class="w100 align-left"
							size="small"
							v-model="item[payDialog.key]"
							:min="0"
					>
						<template slot="append">{{ unitName }}</template>
					</el-input>
				</el-col>
			</el-row>
			<div class="line-row text-center mt20">
				<el-button size="small" @click="payDialog.visible = false">取消</el-button>
				<el-button size="small" type="primary" @click="savePayEdit">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import {comparePayEdit} from "@/api/modules/trackAudit";
export default {
	name:'track-data-comparison',
	props: {
		listData: {
			type: Array,
			default: []
		},
		// 当前单位名称
		unitName: {
			type: String,
			default: '元'
		}
	},
	data() {
		return {
			tableH: 100,
			expandKeys: [],
			tableData: [],
			// 列过滤数组
			filterColumns: {
				current: ['taostValue', 'costMoney', 'tostValue', 'sunMoney'],
				total: ['applyMoney', 'approvalMoney', 'visaMoney', 'payMoney'],
				Declare: []
			},
			// 支付金额弹窗
			payDialog: {
				visible: false,
				width: '600px',
				type: 'edit',
				title: '设置支付金额',
				key: ''
			},
			editData: []
		}
	},
	created() {
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 0) {
				return 'project-row'
			} else if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},
		
		// 重新调整 表格高度
		resizeTable() {
			if (this.$refs.xTable) {
				this.$refs.xTable.doLayout()
				this.tableH = this.$refs.tableContent.offsetHeight
			}
		},

		// 打开编辑支付金额 弹窗
		setPayMoney(title, key) {
			this.payDialog.title = title
			this.payDialog.key = key
			let arr = JSON.parse(JSON.stringify(this.tableData)) || [];
			arr.map(x => {
				x.sunMoney = this.unitName === '元' ? x.sunMoney : parseFloat(x.sunMoney) / 10000
			})
			this.editData = arr.filter(x => x.id && x.id !== '')
			this.payDialog.visible = true
		},

		// 保存支付金额编辑的修改
		savePayEdit() {
			let arr = JSON.parse(JSON.stringify(this.editData)) || []
			arr.map(x => {
				x.sunMoney = this.unitName === '元' ? x.sunMoney : parseFloat(x.sunMoney) * 10000
			})
			comparePayEdit({sunMoney: arr})
					.then(res=> {
						// 刷新列表
						this.$emit('refresh')
					})
					.catch(err => {})
			this.payDialog.visible = false
		},
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		})
	},

	watch: {
		listData(val) {
			this.tableData = val
		},
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
}
</script>
<style lang="less">
	.track-comparison-table {
		.cursor-pointer {
			cursor: pointer;
			color: #96d5d9;
		}
		.line-row {
			line-height: 32px;
		}
	}
</style>